import { styled } from "goober";

const Dot = styled("div")`
  position: relative;
  flex-shrink: 0;
  width: var(--dot-size);
  height: var(--dot-size);

  &::before {
    content: "";
    position: absolute;
    inset: 8.333%;
    border-radius: 50%;
    background: var(--dot-outer);
  }

  &::after {
    content: "";
    position: absolute;
    inset: 25%;
    border-radius: 50%;
    background: var(--dot-inner);
  }
`;

export function StatusDot({
  color,
  size = 12,
}: {
  color: string;
  size?: number;
}) {
  return (
    <Dot
      style={
        {
          "--dot-size": `${size}px`,
          "--dot-outer": `var(--${color}-400)`,
          "--dot-inner": `var(--${color}-600)`,
        } as React.CSSProperties
      }
    />
  );
}
